export const GET_TASK_FORM = 'EPIC/GET_TASK_FORM';
export const GET_TASK_FORM_LOADING = 'EPIC/GET_TASK_FORM_LOADING';
export const GET_TASK_FORM_SUCCESS = 'EPIC/GET_TASK_FORM_SUCCESS';
export const GET_TASK_FORM_FAILURE = 'EPIC/GET_TASK_FORM_FAILURE';
